var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"content"},[_c('NameDetails',{attrs:{"baseInfo":_vm.baseInfo}}),_c('NameRecord',{attrs:{"baseInfo":_vm.baseInfo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }